export const messages = {
  vehicleCreation: 'Vehicle created',
  appointmentCreation: 'Appointment created',
  customerCreation: 'Customer created',
  estimateSent: 'Estimate sent',
  estimateDepositSent: 'Estimate deposit sent',
  estimateCreated: 'Estimate created',
  estimateSave: 'Estimate saved',
  estimateArchived: 'Repair order archived',
  estimateApproved: 'RO approved manually',
  estimateApprovedByCustomer: 'RO approved by customer',
  orderStatusUpdated: 'Order status updated',
  emailSent: 'Email sent',
  invoiceSent: 'Invoice sent',
  partCreation: 'Part created',
  feesCreation: 'Fees created',
  discountCreation: 'Discount created',
  bundleCreated: 'Flat rate created',
  cannedServiceCreation: 'Service created',
  cannedServiceDeleted: 'Service removed',
  customerInfoUpdate: 'Customer saved',
  customerSaved: 'Customer saved',
  vehicleInfoUpdate: 'Vehicle saved',
  vehicleInfoUpdateFR: 'Véhicule sauvegardé',
  cannedServiceUpdate: 'Service saved',
  settingUpdate: 'Setting saved',
  partUpdate: 'Part saved',
  feesUpdate: 'Fees saved',
  passthroughFeesUpdate: "Passthrough tax updated: fee item's price was set to be the same as its cost",
  discountUpdate: 'Discount saved',
  bundleUpdate: 'Flat rate saved',
  appointmentDateChange: 'Event saved',
  technicianChange: 'Event saved',
  appointmentDelete: 'Event deleted',
  companyProfileCreated: 'Profile created',
  companyNameCreated: 'Company created',
  companyProfileUpdated: 'Profile saved',
  newTagCreated: 'Tag created',
  tagDeleted: 'Tag removed',
  statusCreated: 'Status created',
  statusUpdated: 'Status updated',
  autoAuthorizeService: 'All pending services are automatically authorized. You can turn this feature off in settings.',
  statusDeleted: 'Status deleted',
  categoryCreated: 'Category created',
  categoryDeleted: 'Category removed',
  tagAlreadySelected: 'Tag already selected',
  supplierCreated: 'Supplier created',
  supplierRemoved: 'Supplier removed',
  fileUploaded: 'File uploaded',
  unAuthorized: 'Unauthorized request',
  inspectionItemCreated: 'Inspection item created',
  inspectionItemSaved: 'Inspection item saved',
  inspectionItemRemoved: 'Inspection item removed',
  PricingCreated: 'Pricing created',
  PricingSaved: 'Pricing saved',
  PricingRemoved: 'Pricing removed',
  appointmentTemplateCreated: 'Appointment template created',
  appointmentTemplateSaved: 'Appointment template saved',
  reminderTemplateCreated: 'Reminder template created',
  reminderTemplateSaved: 'Reminder template saved',
  cannedInspectionCreated: 'Canned inspection created',
  cannedInspectionSaved: 'Canned inspection saved',
  driveTypeCreated: 'Drive type created',
  vehicleColorCreated: 'Vehicle color created',
  vehicleTransmitionCreated: 'Vehicle transmition created',
  enterUsername: 'Please enter your email',
  enterPassword: 'Please enter your password',
  enterEmail: 'Please enter your email',
  enterPhone: 'Please enter your phone',
  enterTitle: 'Please provide title',
  enterConfirmPassword: 'Please enter confirmation password',
  communicationPreference: 'Select email or SMS',
  selectCustomer: 'Select Customer',
  passwordMismatch: 'Password & confirm password are not same.',
  samePrimarySecondaryNumber: "Primary & secondary number can't be same",
  inValidEmail: 'Email is not valid',
  inValidWebsite: 'Website is not valid, e.g. https://www.yourbusiness.com',
  urlRequired: 'Google review link is required',
  inValidURL: 'Website URL is not valid',
  inValidPhone: 'Phone is invalid',
  notUniqueContact: 'Number already exist',
  notUniqueEmail: 'Email already exists',
  notUniqueName: 'Name already exist',
  paymentCreated: 'Payment recorded',
  paymentCreatedFR: 'Paiement enregistré',
  paymentSaved: 'Payment recorded',
  paymentSavedFR: 'Paiement enregistré',
  invalidOrMissing: 'Invalid or missing',
  successfullyUpdated: 'Successfully updated',
  validTime: 'Please select valid time',
  reviewRequestSent: 'Review request sent',
  reviewRequestReceiptSent: 'Review request and receipt sent',
  receiptSent: 'Receipt sent',
  tireSaved: 'Tire saved',
  tireStorageSaved: 'Tire storage saved',
  updateServiceAuth: 'Please update status for services before continuing.',
  authorizeAllServices: 'Please authorize all services before continuing',
  updateSerivceToGenInvoice: 'Please select the authorization status of services before generating Invoice',
  confirmDeletePart: `Are you sure you want to delete this Part?
  Once deleted, this Part will be removed from all services but
  will still be present in the RO's it was previously added!
  `,
  confirmDeleteCannedService: `Are you sure you want to delete this service?
  Once deleted, this service won't appear on new RO's but will still be present
  in the RO's it was previously added!`,
  confirmSendNow: `This campaign will send [SMS_count] SMS to [Customer_count] customers. Are you sure you want to launch campaign right now?`,
  authorizationMsg: `Please select the authorization status of services before making payment`,
  signatureMsg: `Your signature is required for the approval process. Please sign here digitally.`,
  signatureMsgFrench: `Votre signature est requise pour l’autorisation des services. Veuillez signer électroniquement ci-dessous`,
  lowerTreadDepthThresholdMsg: 'Must be between 1 to 32',
  classificationPrivilegeMsg: 'Only privileged users with catalog classification management access are able to perform this action',
  salesCodePrivilegeMsg: 'Only privileged users with create/update sales code and group access are able to perform this action',
  myFleetCustomerDisconnected: 'Customer disconnected successfully',
  tireStorageCountMessage: 'A storage record can include up to 6 tires (4 for the vehicle + 2 spares). The quantity has been adjusted to match this limit.'
}
  ;
